import { render, staticRenderFns } from "./Quarters40.vue?vue&type=template&id=0b9166d8&lang=pug"
import script from "./Quarters40.vue?vue&type=script&lang=js"
export * from "./Quarters40.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports